const cookie = {
  // 读取cookie
  get: key => {
    var cookieName = `${encodeURIComponent(key)}=`
    var cookieStart = document.cookie.indexOf(cookieName)
    var cookieValue = ''
    if (cookieStart > -1) {
      var cookieEnd = document.cookie.indexOf(';', cookieStart)
      if (cookieEnd == -1) {
        cookieEnd = document.cookie.length
      }
      cookieValue = decodeURIComponent(
        document.cookie.substring(
          `${cookieStart}${cookieName.length}`,
          cookieEnd
        )
      )
    }
    return cookieValue
  },
  // 创建cookie
  set: (key, value, expires, path, domain, secure) => {
    var cookieText = ''
    expires = expires * 1000 * 60 * 60 * 24
    var expires_date = new Date(new Date().getTime() + expires)
    cookieText = `${cookieText}${encodeURIComponent(key)}=${encodeURIComponent(
      value
    )}`

    if (expires) {
      cookieText = `${cookieText}; expires=${expires_date.toGMTString()}`
    }
    if (path) {
      cookieText = `${cookieText}; path=${path}`
    }
    if (domain) {
      cookieText = `${cookieText}; domain=${domain}`
    }
    if (secure) {
      cookieText = `${cookieText}; secure`
    }
    document.cookie = cookieText
  },
  // 删除cookie
  clear: key => {
    cookie.set(key, '', -1)
  },
  // 检查cookie
  check: key => {
    var value = cookie.get(key)
    if (value == '' || value == null) {
      return false
    } else {
      return true
    }
  }
}
const localStorage = {
  // 读取localStorage
  getItem: key => {
    try {
      return JSON.parse(window.localStorage.getItem(key))
    } catch (err) {
      return window.localStorage.getItem(key)
    }
  },
  // 创建localStorage
  setItem: (key, value) => {
    window.localStorage.setItem(key, JSON.stringify(value))
  },
  // 移除指定localStorage
  removeItem: key => {
    window.localStorage.removeItem(key)
  },
  // 清空所有localStorage
  clear: () => {
    window.localStorage.clear()
  }
}
const sessionStorage = {
  // 读取sessionStorage
  getItem: key => {
    try {
      return JSON.parse(window.sessionStorage.getItem(key))
    } catch (err) {
      return window.sessionStorage.getItem(key)
    }
  },
  // 创建sessionStorage
  setItem: (key, value) => {
    // window.sessionStorage.setItem(key, JSON.stringify(value))
    var storage = window.sessionStorage;
    var setItemEvent = new Event("setItemEvent");
    var oldValue = storage[key];
    setItemEvent.key = key;
    // 新旧值深度判断，派发监听事件,监听sessionStorage的变化
    if (oldValue !== value) {
      setItemEvent.newValue = JSON.stringify(value);
      setItemEvent.oldValue = JSON.stringify(oldValue);
      window.dispatchEvent(setItemEvent);
      storage[key] = JSON.stringify(value);
      return true;
    }
    return false;
  },
  // 移除指定sessionStorage
  removeItem: key => {
    window.sessionStorage.removeItem(key)
  },
  // 清空所有sessionStorage
  clear: () => {
    window.sessionStorage.clear()
  }
}

export { cookie, localStorage, sessionStorage }



// WEBPACK FOOTER //
// ./src/assets/js/storage.js